import styled from 'styled-components';
import breakpoint from 'styled-components-breakpoint';

export const Container = styled.section`
  text-align: center !important;
  
  margin-bottom: 30px;
  
  ${breakpoint('tablet')`
     margin-bottom: 60px;
  `}
`;

export const Title = styled.h2`
  margin: 20px 20px 10px;
  
  ${breakpoint('tablet')`
    font-size: 34px;
    max-width: 60%;
    margin: 0 auto;
    padding: 20px;
  `}
`;

export const Subheading = styled.p`
  font-family: "Brown-Pro-Light",AdobeBlank,Serif;
  font-weight: 300;
  margin: 5px 0 40px;
  font-size: 16px;
  color: #333;
  display: block;
`;

export const HeroImageContainer = styled.div`
  margin: 20px;
  overflow: hidden;
`;

export const HeroImage = styled.img`
  border-radius: 4px;
  max-width: 1000px;
  margin: 0 auto;
  width: 100%;
`;

export const SocialLinks = styled.span`
  position: relative;
  margin-left: -8px;
  z-index: 11;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 33px;
  top: 90px;
  cursor: pointer;
`;

export const SocialLink = styled.a`
    width: 50px;
    height: 80px;
    display: inline-block;
    
    // ${breakpoint(`tablet`)`
    //   height: 45px;
    // `};
  
  img {
    max-width: 100%;
  }
`;

export const MachineContainer = styled.span`
  margin-top: -15px;
  display: block;
  position: relative;
  margin-bottom: 30px;
  z-index: 10;
`;

export const Label = styled.p`
  font-family: "Brown-Pro-Bold", AdobeBlank, Serif;
  font-weight: 500;
  margin-bottom: 10px;
  margin-top: 0px;
  font-size: 18px;
  display: block;
  width: 100%;
  
  ${breakpoint('tablet')`
    width: 93%;
  `};
`;

export const Content = styled.span`
  display: block;
  margin-top: -80px !important;
  
  div {
    max-width: 100% !important;
  }
  
  // ${breakpoint('tablet')`
  //   .richTextContainer {
  //     &:first-of-type {
  //       width: 85%;
  //       margin-left: 20%;
  //     }
  //   }
  // `};
  
  .quote {
    border-top: 6px solid #000;
    border-bottom: 6px solid #000;
    margin: 20px;
    width: auto;
    
    h1 {
      font-family: "Brown-Pro-Regular", AdobeBlank, Serif;
      font-size: 24px;
     
      font-weight: 300;
      line-height: 28px;
      padding: 0 20px;
    }
    
    section {
      margin: 0;
      padding: 0;
      
      ${breakpoint('tablet')`
        padding: 20px;
      `}
    }
  }
  
  ${breakpoint('tablet')`
    max-width: 1000px;
    margin: auto;
  `}
`;
